import React from 'react';
import { Helmet } from 'react-helmet-async';

const Terms = () => {
  return (
    <div style={{paddingTop: '100px'}}>
      <Helmet>
        <title>Terms of Service - RMQ Digital</title>
        <meta name="description" content="RMQ Digital terms of service for customer communication platform services." />
      </Helmet>
      
      <section style={{padding: '4rem 2rem', background: '#f9fafb'}}>
        <div style={{maxWidth: '1200px', margin: '0 auto'}}>
          <h1 style={{fontSize: '3rem', fontWeight: '800', marginBottom: '1rem', color: '#1f2937', fontFamily: 'Space Grotesk'}}>Terms of Service</h1>
          
          <div style={{maxWidth: '800px', margin: '0 auto', lineHeight: '1.8'}}>
            <p style={{marginBottom: '2rem', fontStyle: 'italic', color: '#6b7280'}}>
              <strong>Last Updated:</strong> December 1, 2025
            </p>

            <h2 style={{color: '#6d28d9', marginBottom: '1rem', fontSize: '1.75rem'}}>1. Acceptance of Terms</h2>
            <p style={{marginBottom: '2rem'}}>
              By accessing and using RMQ Digital's services, you accept and agree to be bound by the terms and provisions of this agreement. 
              If you do not agree to these terms, please do not use our services.
            </p>

            <h2 style={{color: '#6d28d9', marginBottom: '1rem', fontSize: '1.75rem'}}>2. Services Offered</h2>
            <p style={{marginBottom: '1rem'}}>
              RMQ Digital provides business communication tools including:
            </p>
            <ul style={{marginBottom: '2rem', paddingLeft: '2rem'}}>
              <li>Customer Notifications (appointment reminders, service updates, account alerts)</li>
              <li>Email Communications (transactional emails, account notifications)</li>
              <li>Communication Management Tools</li>
              <li>Workflow Automation</li>
              <li>Analytics and Reporting</li>
              <li>API Integration</li>
            </ul>

            <h2 style={{color: '#6d28d9', marginBottom: '1rem', fontSize: '1.75rem'}}>3. User Responsibilities</h2>
            <p style={{marginBottom: '1rem'}}>Businesses using our platform must:</p>
            <ul style={{marginBottom: '2rem', paddingLeft: '2rem'}}>
              <li>Obtain explicit opt-in consent from their customers</li>
              <li>Provide accurate sender information</li>
              <li>Respect STOP/UNSUBSCRIBE requests immediately</li>
              <li>Comply with TCPA, CTIA, and carrier policies</li>
              <li>Maintain records of consent and opt-out requests</li>
              <li>Use services only for legal, compliant messaging purposes</li>
            </ul>

            <h2 style={{color: '#6d28d9', marginBottom: '1rem', fontSize: '1.75rem'}}>4. Consent Requirements</h2>
            <div style={{background: '#ede9fe', padding: '1.5rem', borderRadius: '12px', marginBottom: '2rem', border: '2px solid #8b5cf6'}}>
              <p style={{fontWeight: '600', color: '#6d28d9', marginBottom: '0.5rem'}}>
                Required Consent:
              </p>
              <p style={{color: '#5b21b6'}}>
                You must ensure end-users have knowingly provided their contact information, been informed about the type of messages they will receive, 
                and provided clear opt-in consent before using our platform to communicate with them.
              </p>
            </div>

            <h2 style={{color: '#6d28d9', marginBottom: '1rem', fontSize: '1.75rem'}}>5. Prohibited Use</h2>
            <p style={{marginBottom: '1rem'}}>You agree NOT to use RMQ Digital for:</p>
            <ul style={{marginBottom: '2rem', paddingLeft: '2rem'}}>
              <li>Unsolicited messages or spam</li>
              <li>Third-party purchased or scraped lists</li>
              <li>Lead generation or affiliate promotions</li>
              <li>Illegal or harmful content</li>
              <li>High-risk categories (loans, crypto, gambling, dating, etc.)</li>
              <li>Messages without proper consent</li>
            </ul>

            <h2 style={{color: '#6d28d9', marginBottom: '1rem', fontSize: '1.75rem'}}>6. Opt-Out Policy</h2>
            <p style={{marginBottom: '2rem'}}>
              End users may opt-out at any time by sending STOP, UNSUBSCRIBE, CANCEL, or QUIT. 
              We enforce immediate message cessation upon opt-out requests.
            </p>

            <h2 style={{color: '#6d28d9', marginBottom: '1rem', fontSize: '1.75rem'}}>7. Service Fees and Payment</h2>
            <p style={{marginBottom: '2rem'}}>
              Service fees are based on your selected plan and usage. Payment is due according to your billing cycle. 
              We reserve the right to suspend services for non-payment.
            </p>

            <h2 style={{color: '#6d28d9', marginBottom: '1rem', fontSize: '1.75rem'}}>8. Service Availability</h2>
            <p style={{marginBottom: '2rem'}}>
              While we strive for high uptime, we do not guarantee uninterrupted service. We may perform maintenance, 
              updates, or experience technical issues that temporarily affect service availability.
            </p>

            <h2 style={{color: '#6d28d9', marginBottom: '1rem', fontSize: '1.75rem'}}>9. Limitation of Liability</h2>
            <p style={{marginBottom: '2rem'}}>
              RMQ Digital shall not be liable for any indirect, incidental, special, consequential, or punitive damages 
              resulting from your use of our services. Our total liability shall not exceed the amount paid by you for services 
              in the past 12 months.
            </p>

            <h2 style={{color: '#6d28d9', marginBottom: '1rem', fontSize: '1.75rem'}}>10. Account Termination</h2>
            <p style={{marginBottom: '2rem'}}>
              We reserve the right to suspend or terminate accounts that violate compliance rules or engage in prohibited messaging activity. 
              You may cancel your account at any time by contacting support.
            </p>

            <h2 style={{color: '#6d28d9', marginBottom: '1rem', fontSize: '1.75rem'}}>11. Modifications to Terms</h2>
            <p style={{marginBottom: '2rem'}}>
              We reserve the right to modify these Terms of Service at any time. We will notify you of material changes 
              by posting the updated terms on our website. Your continued use of our services after such changes constitutes 
              acceptance of the modified terms.
            </p>

            <h2 style={{color: '#6d28d9', marginBottom: '1rem', fontSize: '1.75rem'}}>12. Governing Law</h2>
            <p style={{marginBottom: '2rem'}}>
              These Terms of Service are governed by the laws of the State of New York, without regard to its conflict 
              of law provisions.
            </p>

            <h2 style={{color: '#6d28d9', marginBottom: '1rem', fontSize: '1.75rem'}}>13. Contact Information</h2>
            <div style={{background: '#f9fafb', padding: '2rem', borderRadius: '12px', border: '1px solid #e5e7eb'}}>
              <p style={{fontWeight: '600', marginBottom: '1rem'}}>RMQ HOLDINGS INC</p>
              <p><strong>DBA:</strong> RMQ Digital</p>
              <p>2022 EAST 9TH STREET<br />BROOKLYN, NY 11223<br />United States</p>
              <p><strong>Owner:</strong> MOSHE QUBRUSI</p>
              <p><strong>EIN:</strong> 99-1828959</p>
              <p style={{marginTop: '1rem'}}><strong>Email:</strong> legal@rmqdigital.com</p>
              <p><strong>Support:</strong> support@rmqdigital.com</p>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Terms;
